export enum SopBlockDetailEvents {
    SOP_BLOCK_DETAIL_CLOSED = 'SOP_BLOCK_DETAIL_CLOSED',
}